export default "__VITE_ASSET__83b18709__"